module.exports = __webpack_public_path__ + "img/logo.a8fed5d0.png";